module.exports = __webpack_public_path__ + "static/media/image2.c843f1d3.png";